"use strict";
if ($('#vue-postcontroller').length) {
    var pc = new Vue({
        el: '#vue-postcontroller',
        data: {
            id: null,
            title: null,
            isFav: null,
            topicsView: [],
            topics: null,
            message: null,
            errormessage: null,
            actions: [],
            isSubscriber: false,
            loginUrl: null,
            showSubscribe: false,
            subscriberId: null,
            subscribeSuccess: false
        },
        mounted: function () {
            epicaAddEventClick('#vue-postcontroller');
        },
        beforeMount: function () {
            this.id = parseInt(this.$el.attributes['data-post-id'].value);
            this.title = this.$el.attributes['data-post-title'].value;
            this.loginUrl = this.$el.attributes['data-loginurl'].value;
            this.isFav = this.$el.attributes['data-post-isfav'].value === "True" ? true : false;
            this.topics = JSON.parse(this.$el.attributes['data-post-topics'].value);
            this.topics.forEach(function (item) {
                item.isLoading = false;
            });
            this.isSubscriber = this.$el.attributes['data-issubscriber'].value === "True" ? true : false;
            this.message = null;
            this.actions = [];
        },
        methods: {
            clearMsg: function () {
                this.message = null;
                this.actions = [];
            },
            execute: function (item) {
                if (item.exec) {
                    switch (item.exec) {
                        case 'subscribe':
                            this.showSubscribe = true;
                            break;
                        default:
                            break;
                    }
                }
            },
            closeSubscribe: function () {
                this.showSubscribe = false;
            },
            updateFav: function () {

                var objToSend = {
                    PostId: this.id,
                    PostTitle: this.title
                };
                this.$http.post('/api/lrplus/favs', objToSend).then(function (response) {

                    if (response.body.success) {

                        this.isFav = !this.isFav;
                        if (this.isFav) {
                            this.message = "Artículo guardado";
                            setTimeout(this.clearMsg, 3000);
                        } else {
                            this.message = "Artículo eliminado";
                            setTimeout(this.clearMsg, 3000);
                        }

                    } else {

                        switch (response.body.errorCode) {
                            case "limit":
                                this.message = this.isSubscriber ? "Ha superado el límite de favoritos" : "Ha llegado al límite de favoritos, suscríbase para ampliar el número de artículos que puede guardar.";
                                if (!this.isSubscriber) {
                                    this.actions.push({ title: "Suscribirse", exec: "subscribe" });
                                    this.actions.push({ title: "Administrar Favoritos", href: "//mas.larepublica.co/articulos-guardados" });
                                }
                                break;
                            case "auth":
                                this.message = "Debe ingresar para guardar el artículo";
                                this.actions.push({ title: "ingresar", href: this.loginUrl });
                                setTimeout(this.clearMsg, 10000);
                                break;
                            default:
                                this.message = "Ha ocurrido un error, intente de nuevo más tarde.";
                                setTimeout(this.clearMsg, 3000);
                                break;
                        }
                    }

                }, function (response) {
                    this.message = "Ha ocurrido un error, intente de nuevo más tarde.";
                    setTimeout(this.clearMsg, 3000);
                });
            },
            addTopic: function (topic, idx) {
                topic.IsLoading = true;

                this.$http.post('/api/lrplus/topics', topic).then(function (response) {
                    topic.IsLoading = false;

                    if (response.body.success) {
                        topic.IsSelected = true;
                        this.message = "Tema agregado satisfactoriamente.";
                        setTimeout(this.clearMsg, 3000);
                    } else {
                        switch (response.body.errorCode) {
                            case "limit":
                                this.message = this.isSubscriber ? "Ha superado el límite de temas" : "Ha superado el límite de temas, suscribase para poder agregar más.";
                                if (!this.isSubscriber) {
                                    this.actions.push({ title: "Suscribirse", exec: "subscribe" });
                                    this.actions.push({ title: "Administrar Temas", href: "//mas.larepublica.co/temas" });
                                }
                                break;
                            case "auth":
                                this.message = "Debe ingresar para agregar el tema.";
                                this.actions.push({ title: "ingresar", href: this.loginUrl });
                                setTimeout(this.clearMsg, 10000);
                                break;
                            default:
                                this.message = "Ha ocurrido un error, intente de nuevo más tarde.";
                                setTimeout(this.clearMsg, 3000);
                                break;
                        }
                    }

                }, function (response) {
                    topic.IsLoading = false;
                    this.message = "Ha ocurrido un error, intente de nuevo más tarde.";
                    setTimeout(this.clearMsg, 3000);
                });
            },
            subscribe: function () {
                if (this.subscriberId) {
                    var subscriber = {
                        Identification: this.subscriberId
                    };
                    this.$http.post('/api/lrplus/subscribe', subscriber).then(function (response) {
                        if (response.body.success) {
                            this.subscribeSuccess = true;

                        } else {
                            this.errormessage = response.body.errorMessage;
                            setTimeout(this.clearErrorMessage, 5000);
                        }
                    }, function (response) {
                        this.errormessage = "Ha ocurrido un error por favor intente de nuevo más tarde";
                        setTimeout(this.clearErrorMessage, 5000);
                    });
                } else {
                    this.errormessage = "Ingrese su número de identificación para poder continuar";
                    setTimeout(this.clearErrorMessage, 5000);
                }
            },
            clearErrorMessage: function () {
                this.errormessage = null;
            }
        }
    });
}